/**
 * ContentLoader — carrega e valida /conteudo em runtime.
 *
 * O conteudo e importado pelo Vite (import.meta.glob), entao ele existe tanto
 * no dev quanto no build. A validacao pesada acontece em npm run build, pelo
 * scripts/validar-conteudo.js; aqui checamos o que impede o jogo de rodar.
 *
 * P5: nada de catch silencioso. Se faltar conteudo, o erro aparece no console
 * em portugues dizendo o arquivo, o campo e o que fazer.
 */

const arquivosDeTarefa = import.meta.glob('/conteudo/tarefas/*.json', { eager: true });
const arquivosRaiz = import.meta.glob('/conteudo/*.json', { eager: true });

function pegar(nome) {
  const chave = `/conteudo/${nome}`;
  const modulo = arquivosRaiz[chave];
  if (!modulo) {
    throw new Error(
      `FAZENDA: nao encontrei conteudo/${nome}. ` +
        `Ele e obrigatorio (secao 4 da ESPECIFICACAO.md). Crie o arquivo e recarregue a pagina.`
    );
  }
  return modulo.default ?? modulo;
}

export class ContentLoader {
  constructor() {
    this.motores = null;
    this.progressao = null;
    this.estacoes = null;
    this.narracao = null;
    this.vocabulario = null;
    this.tarefas = [];
  }

  carregar() {
    this.motores = pegar('motores.json');
    this.progressao = pegar('progressao.json');
    this.estacoes = pegar('estacoes.json');
    this.narracao = pegar('narracao.json');
    this.vocabulario = pegar('vocabulario.json');

    this.tarefas = Object.entries(arquivosDeTarefa).map(([caminho, modulo]) => {
      const tarefa = modulo.default ?? modulo;
      if (!tarefa.sucesso?.mundo) {
        throw new Error(
          `FAZENDA: a tarefa ${caminho} nao tem sucesso.mundo. ` +
            `D11: toda tarefa muda a fazenda. Preencha o campo ou apague a tarefa.`
        );
      }
      return tarefa;
    });

    if (this.tarefas.length === 0) {
      throw new Error(
        'FAZENDA: nenhuma tarefa encontrada em conteudo/tarefas. ' +
          'Crie ao menos um JSON de tarefa seguindo a secao 6 da ESPECIFICACAO.md.'
      );
    }

    console.info(
      `FAZENDA: conteudo carregado — ${this.tarefas.length} tarefas, ` +
        `${this.motores.motores.length} motores declarados.`
    );

    this.avisarNarracaoPendente();
    return this;
  }

  /** D5 exige audio. Enquanto nao houver, o aviso fica alto no console. */
  avisarNarracaoPendente() {
    const pendentes = Object.entries(this.narracao.narracoes ?? {})
      .filter(([, n]) => !n.audio)
      .map(([id]) => id);

    if (pendentes.length > 0) {
      console.warn(
        `FAZENDA: ${pendentes.length} narracao(oes) ainda sem audio: ${pendentes.join(', ')}. ` +
          'D5 proibe instrucao so por texto. Grave os audios, coloque em /assets/audio e ' +
          'preencha o campo "audio" em conteudo/narracao.json antes de testar com as criancas.'
      );
    }
  }

  tarefaPorId(id) {
    return this.tarefas.find((t) => t.id === id) ?? null;
  }

  /** Devolve { texto, audio } da narracao pedida. */
  narracaoPorId(id) {
    const n = this.narracao.narracoes?.[id];
    if (!n) {
      throw new Error(
        `FAZENDA: a narracao "${id}" nao existe em conteudo/narracao.json. ` +
          'Adicione a entrada ou corrija o id no JSON da tarefa.'
      );
    }
    return n;
  }
}
